import currencyUnitTypeSelector from './currency-unit-type'

export default [currencyUnitTypeSelector]
